module.exports = __webpack_public_path__ + "../resources/images/emptySearch-40e25a4d3d8d88409f776d29f9ce8f54.svg";